/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
import LoadMoreBlog from './site/loadMoreBlog';
// import HubspotForm from './site/hubspotForm';
import Animations from './site/animations';
import Tabs from './site/tabs';
import Counter from './site/counter';
import EqualHeight from './site/equalHeight';
import Helpers from './site/helpers';
import Gsap from './site/gsap';
import LoadMoreResources from './site/loadMoreResources';
import BannerForm from './site/bannerForm';
// import LocationAutocomplete from './site/locationAutocomplete';
import Subscribe from './site/subscribe';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	LoadMoreBlog.init();
// 	HubspotForm.init();
	Animations.init();
	Tabs.init();
	Counter.init();
	EqualHeight.init();
	Helpers.init();
	Gsap.init();
	LoadMoreResources.init();
	BannerForm.init();
	Subscribe.init();
	// LocationAutocomplete.initAutocomplete();
	// Referral.timestamp();
});
